import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/user-profile')({
  component: UserProfileRedirect,
});

function UserProfileRedirect() {
  return <Navigate to="/account" search={{ tab: 'profile' }} />;
}
